interface TagsContainerProps {
  category: string;
}

const TagsContainer = ({category}: TagsContainerProps) => {
  return (
    <div className='absolute top-3 left-3 flex flex-row items-center justify-end gap-1 mb-1'>
      <span className='rounded-lg bg-primary px-2 py-1 text-[10px] tracking-wide font-semibold text-white'>
        {category}
      </span>
    </div>
  );
}

export default TagsContainer;